import { render, staticRenderFns } from "./VTokenChequeModal.vue?vue&type=template&id=2c463f58&scoped=true&"
import script from "./VTokenChequeModal.vue?vue&type=script&lang=js&"
export * from "./VTokenChequeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c463f58",
  null
  
)

export default component.exports